import { IonCard, IonCardContent, IonProgressBar, IonInput } from '@ionic/react';
import GlobalContext from './domain/GlobalContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import ListView from './components/ListView';
import { Initiative } from './domain/Types';
import { api } from './domain/ApiService';

const Verification: React.FC = () => {

  const { user, initiative, setInitiative } = useContext(GlobalContext);
  const { initiatives, setInitiatives } = useContext(GlobalContext);
  const [ filteredInitiatives, setFilteredInitiatives ] = useState<Initiative[]>([]);
  const [ templates, setTemplates ] = useState<Initiative[]>([]);
  const [ query, setQuery ] = useState('');
  const [ clients, setClients ] = useState<Initiative[]>([]);
  

  useEffect(() => {

    if (initiatives != null) {
      if (initiatives?.length === 1) {
         listInitiatives()
      }
      setTemplates(initiatives.filter(initiative => {
        return initiative.template ? initiative.template : false;
      }));
      let initiativess = initiatives.sort((a, b) => a.name.localeCompare(b.name));
      let filtered = initiativess.filter(initiative => {
        if (user?.auth_id && initiative && !initiative.template) {

            const isOwnerOrCollaborator = !initiative.owners || !initiative.collaborators || initiative.owners.includes(user.auth_id) || initiative.collaborators.includes(user.auth_id);
            const isCollaboratorOrAllUsers = !initiative.collaborators || initiative.collaborators.includes(user.auth_id) || initiative.collaborators.length === 0 || initiative.collaborators.includes("allUsers");
            return isOwnerOrCollaborator || isCollaboratorOrAllUsers;
        }
        return false;
      });
      // setFilteredInitiatives(filtered);

      if (user?.role === 'superadmin') {
        setClients(initiatives.filter((item: any) => item.name));
      } else setClients(filtered.filter((item: any) => item.name));
    }

  }, [initiatives]);

  const listInitiatives = useCallback(async () => {
      try {
  
        if (user != null) {
  
          const response = await api("/initiative/list", {}, initiative);
          setInitiatives(response);
          window.dispatchEvent(new Event('initiativesLoaded'));
        }
    } catch (err) {
        console.error('Failed to fetch initiatives:', (err as Error).message);
      }
    }, [user, initiative]);
    
  const handleClick = (clickedInitiative: Initiative) => {
    localStorage.setItem('initiative', JSON.stringify(clickedInitiative));
    setInitiative(clickedInitiative);
  };

  const handleSearchChange = (event: CustomEvent<{ value?: string | null }>) => {
    const qLower = event.detail.value?.toLowerCase();
    if (initiatives?.length && qLower) {
      setClients(initiatives.filter((item: any) => item.name.toLowerCase().includes(qLower)))
    }
    setQuery(event.detail.value as string);
  }

  return (

    <>
    {initiatives != null ?
    <>
      <IonCard className='filled' style={{ padding: "10px" }}>
      <IonInput 
                className='form-element'
                style={{width: "98%", marginLeft: "10px"}}
                label="Search"
                labelPlacement="floating"
                fill="outline"
                placeholder="Search"
                onIonInput={handleSearchChange}
            />
        <IonCardContent>
          <ListView<Initiative>
              items={ clients }
              columns={[
                { attribute: 'name', label: 'Name', size: "small", primary: true },
                { attribute: 'instructions', label: 'Instructions', size: "small" }
              ]}
              onClick={handleClick}
              enableReorder={false}
              defaultLayout={'cards'}
              showActions={true}
              showAddBtn={false}
              showSideDots={false}
              viewName={'home'}
          />
        </IonCardContent>
      </IonCard>
      {/* {user?.role === 'admin' &&
        <IonCard className='filled' style={{ padding: "10px" }}>
          <IonCardContent>
            <ListView<Initiative>
                items={templates}
                columns={[
                  { attribute: 'name', label: 'Name', size: "small", primary: true },
                  { attribute: 'instructions', label: 'Instructions', size: "small" }
                ]}
                onClick={handleClick}
                enableReorder={false}
                defaultLayout={'cards'}
                showActions={false}
            />
          </IonCardContent>
        </IonCard>
      } */}
    </>
    :
      <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>
    }
    </>

  );
};

export default Verification;